/* storybook-check-ignore */

import { IArticle } from '../../declarations/contentful';
import { Text, Box } from '@opendoor/bricks/core';
import { Fragment } from 'react';
import typography from './typography';

const SpotlightArticles: React.FC<{ articles?: Array<IArticle>; sectionTitle: string }> = (
  props,
) => {
  if (!props.articles || props.articles.length === 0) {
    return null;
  }
  return (
    <>
      <Text marginY={[6, null, null, 6]} {...typography.h3}>
        {props.sectionTitle}
      </Text>
      {props.articles.map((article) => {
        if (!article.fields) {
          return null;
        }
        return (
          <Fragment key={article.fields.slug}>
            <Box borderBottom={'2px solid #f2f2f2'} as="article" paddingTop="6" paddingBottom="6">
              {/* article name as h1 so that the <article> tag properly links to the article */}
              <a href={article.fields.slug}>
                <Text marginTop="0" marginBottom="0" {...typography.spotlightHeader} as="h1">
                  {article.fields.articleName}
                </Text>
              </a>
              <Text {...typography.spotlightAuthor} marginTop="0">
                {article.fields?.authors?.[0].fields.displayName}
              </Text>
            </Box>
          </Fragment>
        );
      })}
    </>
  );
};

export default SpotlightArticles;
